<router-outlet />

@if (isAuthenticatingSignal()) {
  <di-loading />
}
